/** Viewport-safe coords for a position:fixed menu under a trigger (split screen / visualViewport). */
export const placeAnchoredMenu = (trigger, { align = 'end', maxWidth = 280 } = {}) => {
  if (!trigger || typeof window === 'undefined') return {};
  const rect = trigger.getBoundingClientRect();
  const vv = window.visualViewport;
  const vw = vv?.width ?? window.innerWidth;
  const vh = vv?.height ?? window.innerHeight;
  const ox = vv?.offsetLeft ?? 0;
  const oy = vv?.offsetTop ?? 0;
  const margin = 8;
  const width = Math.min(maxWidth, Math.max(0, vw - margin * 2));
  const minLeft = ox + margin;
  const maxLeft = ox + vw - margin - width;
  let left = align === 'start' ? rect.left + ox : rect.right + ox - width;
  if (maxLeft >= minLeft) {
    left = Math.min(Math.max(left, minLeft), maxLeft);
  } else {
    left = minLeft;
  }
  let top = rect.bottom + oy + 6;
  const roomBelow = oy + vh - margin - top;
  if (roomBelow < 96) {
    top = Math.max(oy + margin, rect.top + oy - 6);
  }
  return { top, left, width, minWidth: 0, maxWidth: width, right: 'auto' };
};

export const subscribeViewport = (onChange) => {
  if (typeof window === 'undefined') return () => {};
  const vv = window.visualViewport;
  window.addEventListener('resize', onChange);
  window.addEventListener('scroll', onChange, true);
  vv?.addEventListener('resize', onChange);
  vv?.addEventListener('scroll', onChange);
  return () => {
    window.removeEventListener('resize', onChange);
    window.removeEventListener('scroll', onChange, true);
    vv?.removeEventListener('resize', onChange);
    vv?.removeEventListener('scroll', onChange);
  };
};
